// Franchise desk: the WhatsApp number customers use for this branch. Read-only. HQ edits numbers
// on Branches & numbers; tokens and phone-number ids are not shown here.
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../services/api';
import { useEngagementScope } from '../context/EngagementScope';
import { Loader, PageHead } from '../components/ui';

const STATUS_TONE = { active: 'ok', disabled: 'muted', error: 'danger' };

function NumberCard({ title, body, channel }) {
  const tone = STATUS_TONE[channel?.status] || 'muted';
  return (
    <div className="de-card" style={{ maxWidth: 560 }}>
      <div className="de-row de-row--between" style={{ gap: 12, marginBottom: 8 }}>
        <div className="de-strong">{title}</div>
        {channel?.status ? <span className={`de-pill de-pill--${tone} de-pill--sm`}>{channel.status}</span> : null}
      </div>
      <div className="de-page-title" style={{ fontSize: 22, marginBottom: 8 }}>
        {channel?.display_number || 'Number not set'}
      </div>
      <div className="de-small de-muted">{body}</div>
      {channel?.label ? <div className="de-small" style={{ marginTop: 10 }}>{channel.label}</div> : null}
    </div>
  );
}

export default function MyNumber() {
  const { branchName, me } = useEngagementScope();
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .listChannels()
      .then(setData)
      .catch((e) => toast.error(e.message || 'Could not load your number'));
  }, []);

  if (!data) return <Loader text="Loading your number…" />;

  const channels = Array.isArray(data.channels) ? data.channels : [];
  const own = channels.find((c) => c.channel === 'whatsapp' && !c.is_main);
  const main = channels.find((c) => c.channel === 'whatsapp' && c.is_main);
  const branch = branchName(me?.franchise_id) || own?.branch_name || 'Your branch';

  return (
    <div>
      <PageHead
        title="Your number"
        sub={`${branch}. Customers message this WhatsApp number. HQ changes numbers; this screen only shows yours.`}
      />
      {own ? (
        <NumberCard
          title="Your branch number"
          channel={own}
          body="Chats on this number are only for your branch. The agent does not ask which branch the customer wants."
        />
      ) : (
        <NumberCard
          title="Organization number"
          channel={main}
          body="Your branch does not have its own WhatsApp number yet. Customers reach you on the organization’s main number, and the agent asks which branch they want."
        />
      )}
    </div>
  );
}
